import anime from 'animejs/lib/anime.es.js';
import { sliceHTMLElements } from '../../js/helpers';

const OverviewPageAnime = () => {
	const content = document.querySelector('.tos-overview__content');
	const title = document.querySelectorAll('.tos-overview__title-sliced span');

	Array.from(title).forEach(element => {
		if (element) {
			sliceHTMLElements(element);
		}
	});

	const tl = anime.timeline({
		easing: 'easeOutExpo',
		duration: 500,
	});

	tl.add({
		targets: '.tos-overview',
		opacity: [0, 1],
	});

	tl.add({
		targets: '.tos-overview__title-sliced .sliced-element',
		opacity: [0, 1],
		easing: 'easeInOutQuad',
		delay: (_, i) => 50 * (i + 1),
	});

	tl.add(
		{
			targets: '.tos-overview__title-animated--burn',
			opacity: [0, 1],
		},
		'-=1750',
	);

	tl.add(
		{
			targets: '.tos-overview__title-animated--heat',
			opacity: [0, 1],
		},
		'-=250',
	);

	Array.from(content.children).forEach(element => {
		if (element) {
			tl.add({
				targets: element,
				delay: 250,
				opacity: [0, 1],
			});
		}
	});

	tl.add({
		targets: '.tos-overview__button-next',
		translateX: [-100, 0],
		opacity: [0, 1],
	});

	tl.add({
		targets: '.tos-overview__button-prev',
		translateX: [100, 0],
		opacity: [0, 1],
	});
};

export default OverviewPageAnime;
